<template>
  <div class="detail-cnt">
    <header class="inner-head">
      <span class="icon-Btn" @click="goBack()">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16">
          <path
            d="M7.993 14.119c.395.432.4 1.127.007 1.558-.39.429-1.019.434-1.418-.004L.297 8.779c-.393-.43-.4-1.122 0-1.56L6.582.326C6.975-.105 7.607-.11 8 .32c.39.428.392 1.121-.007 1.559L3.414 6.902h13.584C17.55 6.902 18 7.39 18 8c0 .606-.452 1.097-1.002 1.097H3.414l4.58 5.023z"
          />
        </svg>
      </span>

      <h2>{{$t('taskDetail')}}</h2>
    </header>

    <section class="mid-cnt">
      <div class="dtl-postbox">
        <h1>{{taskDetail.title}}</h1>
        <div class="info-box" v-if="taskDetail.delivery_time">
          <h2>{{$t('taskCompletionTime')}}:</h2>
          <p>{{ taskDetail.delivery_time.slice(0, taskDetail.delivery_time.indexOf('T')) }}</p>
        </div>
        <div class="info-box">
          <h2>{{$t('earning')}}:</h2>
          <p>&#8377; {{taskDetail.payment}} {{$t('perTaskCompleted')}}</p>
        </div>
        <div class="info-box">
          <h2>{{$t('totalAvailableTask')}}:</h2>
          <p>{{Math.trunc(taskDetail.no_of_task - taskDetail.number_of_task_accepted)}}</p>
        </div>

        <div class="info-box">
          <h2>{{$t('totalCompletedTask')}}:</h2>
          <p>{{taskDetail.no_of_task_completed}}</p>
        </div>
      </div>
      <div
        class="how-workbox"
        v-if="taskDetail.task_details && taskDetail.task_details[0].length > 0"
      >
        <h3>{{$t('howToCompleteTasks')}}</h3>
        <div v-html="(taskDetail.task_details[0][0].text)"></div>

        <div v-if="taskDetail.task_fam === 'Mall91 Sales'" class="go-to-prod">
          <button type="button" @click="goToProdOpen(taskDetail.deep_link)">{{$t('goToProduct')}}</button>
        </div>
      </div>

      <div v-if="taskDetail.task_fam === 'Call Center'" class="order_action go-to-prod">
        <h5 style="text-align:left">{{$t('orderDetail')}}</h5>
        <ul class="call_detail_item" v-if="callOrderId">
          <li class="inputFeild">
            <label>
              <span>{{$t('OrderId')}} :</span>
            </label>
            <input :placeholder="$t('name')" v-model="callOrderId.orderId" readonly />
          </li>
          <li class="inputFeild">
            <label>
              <span>{{$t('amount')}} :</span>
            </label>
            <input :placeholder="$t('name')" v-model="callOrderId.orderAmount" readonly />
          </li>
          <li class="inputFeild">
            <label>
              <span>{{$t('productName')}} :</span>
            </label>
            <textarea :placeholder="$t('name')" v-model="callOrderId.itemName" readonly></textarea>
          </li>
          <li class="inputFeild">
            <label>
              <span>{{$t('paymentMode')}} :</span>
            </label>
            <input :placeholder="$t('paymentMode')" v-model="callOrderId.PaymentMethod" readonly />
          </li>
          <li class="inputFeild">
            <label>
              <span>{{$t('name')}} :</span>
            </label>
            <input
              :placeholder="$t('name')"
              v-model="callOrderId.buyerName"
              :readonly="!isEditable"
            />
            <i class="material-icons" v-if="isEditable">create</i>
          </li>

          <li class="inputFeild">
            <label>
              <span>{{$t('phoneNumber')}} :</span>
            </label>
            <input
              :placeholder="$t('phoneNumber')"
              v-model="callOrderId.PhoneNumber"
              :readonly="!isEditable"
            />
            <i class="material-icons" v-if="isEditable">create</i>
          </li>

          <li class="inputFeild">
            <label>
              <span>{{$t('address')}} :</span>
            </label>
            <textarea
              :placeholder="$t('address')"
              v-model="callOrderId.Address"
              cols="auto"
              :readonly="!isEditable"
            ></textarea>
            <i class="material-icons" v-if="isEditable">create</i>
          </li>
          <li class="inputFeild">
            <label>
              <span>{{$t('city')}} :</span>
            </label>
            <input :placeholder="$t('city')" v-model="callOrderId.City" :readonly="!isEditable" />
            <i class="material-icons" v-if="isEditable">create</i>
          </li>
          <li class="inputFeild">
            <label>
              <span>{{$t('state')}} :</span>
            </label>
            <input :placeholder="$t('state')" v-model="callOrderId.State" :readonly="!isEditable" />
            <i class="material-icons" v-if="isEditable">create</i>
          </li>
          <li class="inputFeild">
            <label>
              <span>{{$t('postOffice')}} :</span>
            </label>
            <input
              :placeholder="$t('postOffice')"
              v-model="callOrderId.PostOffice"
              :readonly="!isEditable"
            />
            <i class="material-icons" v-if="isEditable">create</i>
          </li>
          <li class="inputFeild">
            <label>
              <span>{{$t('pincode')}} :</span>
            </label>
            <input
              :placeholder="$t('pincode')"
              v-model="callOrderId.Pincode"
              :readonly="!isEditable"
            />
            <i class="material-icons" v-if="isEditable">create</i>
          </li>
        </ul>

        <div class="call-accepted">
          <p>{{$t('orderAcceptedOrRejected')}}</p>
          <div style="padding:0 15px" v-if="callOrderId.status === 0">
            <button type="button" @click="acceptedOrder(callOrderId.id)">{{$t('orderAccepted')}}</button>
            <button
              type="button"
              class="deny"
              @click="denyOrder(callOrderId.id)"
            >{{$t('orderDenied')}}</button>
          </div>
          <div style="padding-bottom: 12px;" v-else>
            <strong
              v-if="callOrderId.status === 1"
              style="color:green;"
            >{{$t('orderStatus')}}: {{$t('orderAccepted')}}</strong>
            <strong
              v-if="callOrderId.status === 2"
              style="color:red;"
            >{{$t('orderStatus')}}: {{$t('orderDenied')}}</strong>
          </div>
        </div>
      </div>
      <div v-if="taskDetail.task_fam === 'Dau'" class="order_action go-to-prod">
      <h5 style="text-align:left">{{$t('userDetail')}}</h5>
        <ul class="call_detail_item" v-if="callOrderId">
          <li class="inputFeild" v-if="callOrderId.name">
            <label>
              <span>{{$t('name')}} :</span>
            </label>
            <input :placeholder="$t('name')" v-model="callOrderId.name" readonly />
            </li>
            <li class="inputFeild" v-else>
             <label>
              <span>{{$t('name')}} :</span>
            </label>
            <input :placeholder="$t('notAvailable')" readonly />
            </li>
          <li class="inputFeild">
            <label>
              <span>{{$t('phoneNumber')}} :</span>
            </label>
            <input :placeholder="$t('phoneNumber')" v-model="callOrderId.phone" readonly />
          </li>
          <li class="inputFeild">
            <label>
              <span>{{$t('walletBalance')}} :</span>
            </label>
            <input :placeholder="$t('walletBalance')" v-model="callOrderId.mcash_balance" readonly />
          </li>
          <li class="inputFeild">
            <label>
              <span>{{$t('mPointBalance')}} :</span>
            </label>
            <input :placeholder="$t('mPointBalance')" v-model="callOrderId.wallet_balance" readonly />
          </li>
        </ul>
        <div class="call-accepted">
          <div style="padding: 12px 0;" v-if="callOrderId.call_complete === 1">
            <strong style="color:green;">{{$t('appBalanceChecked')}}</strong>
          </div>
        </div>
      </div>
      <div v-if="taskDetail.task_fam === 'Khel91'" class="order_action go-to-prod">
      <h5 style="text-align:left">{{$t('userDetail')}}</h5>
        <ul class="call_detail_item" v-if="callOrderId">
          <li class="inputFeild" v-if="callOrderId.name">
            <label>
              <span>{{$t('name')}} :</span>
            </label>
            <input :placeholder="$t('name')" v-model="callOrderId.name" readonly />
            </li>
            <li class="inputFeild" v-else>
             <label>
              <span>{{$t('name')}} :</span>
            </label>
            <input :placeholder="$t('notAvailable')" readonly />
            </li>
          <li class="inputFeild">
            <label>
              <span>{{$t('phoneNumber')}} :</span>
            </label>
            <input :placeholder="$t('phoneNumber')" v-model="callOrderId.phone" readonly />
          </li>
        </ul>
        <div class="call-accepted">
          <div style="padding: 12px 0;" v-if="callOrderId.call_complete === 1">
            <strong style="color:green;">{{$t('gameDownload')}}</strong>
          </div>
        </div>
      </div>
      <div class="task-submit">
        <h2>{{$t('seeInvideo')}}</h2>

        <div class="video-box">
          <iframe
            width="560"
            height="315"
            :src="taskDetail.video"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
            v-if="taskDetail.video"
          ></iframe>

          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/McqKpz1RDIM"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
            v-else
          ></iframe>
        </div>
        <div v-if="!['Call Center','Dau','Khel91'].includes(taskDetail.task_fam) && notCallFamTask">
          <button
            class="button submit-btn"
            @click="submitTask(taskDetail.Task_id)"
            v-if="this.$route.query.myTaskIndex"
          >{{$t('submitYourTask')}}</button>
        </div>
      </div>
    </section>

    <CustomToaster :dataValue="toasterData" v-if="isValidDetail" />
    <div class="loader" v-if="loading">
      <img src="../assets/images/loader.gif" alt="loader" />
    </div>
  </div>
</template>
<script>
import "../assets/css/task-detail.css";
import ApiCaller from "../utils/apicaller";
import constant from "../utils/constant";
import CustomToaster from "../components/Common/CustomToaster";
import { SessionHelper, X_AUTH_ID } from "../utils/session";

export default {
  name: "TaskDetail",
  components: {
    CustomToaster
  },
  data() {
    return {
      taskDetail: [],
      loading: false,
      selected: [],
      isValidDetail: false,
      toasterData: {},
      taskDescription: [],
      isEligible: {},
      callingDetails: {},
      getUserDetail: {},
      call_detail: false,
      isPayment: true,
      callOrderId: {},
      isEditable: false,
      notCallFamTask: false
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    goToProdOpen(data) {
      try {
        JSBridgePlugin.genericIntentLaunch(data);
      } catch (err) {
        console.log(err);
      }
    },

    getTaskDetail() {
      this.loading = true;
      ApiCaller(
        constant.BASE_API_URL,
        "tasks/taskdetails/?task_id=" + this.$route.query.myTaskIndex,
        "get"
      )
        .then(data => {
          this.isEligible = data;
          this.taskDetail = data.data[0];
          this.taskDescription = data.data[0].task_details[0][0].text.split(
            "\r\n"
          );
          if (this.taskDetail.task_fam !== "Call Center" || this.taskDetail.task_fam !== "Dau") {
            this.notCallFamTask = true;
          }
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
        });
    },

    getCallingDetails() {
      this.loading = true;
      ApiCaller(
        constant.BASE_API_URL,
        "tasks/calling_details/?task_id=" + this.$route.query.myTaskIndex,
        "get"
      )
        .then(data => {
          this.callingDetails = data.data;
          this.call_detail = true;
          this.loading = false;
        })
        .catch(err => {
          this.toasterData = {
            msg: err.response.data.message,
            color: "#ff4643",
            iconName: "error"
          };
          this.isValidDetail = true;
          this.loading = false;
        });
    },
    validateFields() {
      const obj = this.callOrderId;
      if (
        !obj.buyerName ||
        !obj.PhoneNumber ||
        !obj.Address ||
        !obj.City ||
        !obj.State ||
        !obj.PostOffice ||
        !obj.Pincode
      ) {
        this.toasterData = {
          msg: this.$t("enterAllFeilds"),
          color: "#e51c24",
          iconName: "close"
        };
        this.isValidDetail = true;
        return false;
      } else {
        if (obj.buyerName.length <= 3) {
          this.toasterData = {
            msg: this.$t("enterValidName"),
            color: "#e51c24",
            iconName: "close"
          };
          this.isValidDetail = true;
          return false;
        }
        if (obj.PhoneNumber.length != "") {
          if (
            !new RegExp(/^[0][6-9]\d{9}$|^[6-9]\d{9}$/g).test(obj.PhoneNumber)
          ) {
            this.toasterData = {
              msg: this.$t("enterValidMobileNumber"),
              color: "#e51c24",
              iconName: "close"
            };
            this.isValidDetail = true;
            return false;
          }
        }
        if (
          obj.Address.length <= 4 &&
          obj.City.length <= 4 &&
          obj.State.length <= 4 &&
          obj.PostOffice.length <= 4
        ) {
          this.toasterData = {
            msg: this.$t("enterValidAddress"),
            color: "#e51c24",
            iconName: "close"
          };
          this.isValidDetail = true;
          return false;
        }
        if (obj.Pincode.length != "") {
          if (!new RegExp(/^[1-9][0-9]{5}$/g).test(obj.Pincode)) {
            this.toasterData = {
              msg: this.$t("enterValidPinNumber"),
              color: "#e51c24",
              iconName: "close"
            };
            this.isValidDetail = true;
            return false;
          }
        }
        return true;
      }
    },
    acceptedOrder(id) {
      if (this.validateFields()) {
        this.loading = true;
        const obj = {
          call_id: id,
          status: 1,
          updated_data: this.callOrderId
        };
        ApiCaller(constant.BASE_API_URL, "tasks/accept_or_deny/", "post", obj)
          .then(data => {
            if (data.success) {
              this.call_detail = false;
              this.isEditable = false;
              this.getTaskDetail();
              if (this.$route.query.orderId) {
                ApiCaller(
                  constant.BASE_API_URL,
                  "tasks/orders/" + "?order_id=" + this.$route.query.orderId,
                  "get"
                )
                  .then(data => {
                    this.loading = false;
                    this.callOrderId = data.data[0].extra;
                  })
                  .catch(err => {
                    this.loading = false;
                  });
              }
            }
            this.loading = false;
          })
          .catch(err => {
            this.loading = false;
          });
      }
    },
    denyOrder(id) {
      if (this.validateFields()) {
        this.loading = true;
        const obj = {
          call_id: id,
          status: 2,
          updated_data: this.callOrderId
        };
        ApiCaller(constant.BASE_API_URL, "tasks/accept_or_deny/", "post", obj)
          .then(data => {
            this.loading = false;
            if (data.success) {
              this.call_detail = false;
              this.isEditable = false;
              this.getTaskDetail();
              if (this.$route.query.orderId) {
                ApiCaller(
                  constant.BASE_API_URL,
                  "tasks/orders/" + "?order_id=" + this.$route.query.orderId,
                  "get"
                )
                  .then(data => {
                    this.loading = false;
                    this.callOrderId = data.data[0].extra;
                  })
                  .catch(err => {
                    this.loading = false;
                  });
              }
            }
          })
          .catch(err => {
            this.loading = false;
          });
      }
    },

    submitTask(id) {
      this.$router.push("/submit-task?taskId=" + id);
    }
  },
  mounted() {
    if (this.$route.query.orderId) {
      ApiCaller(
        constant.BASE_API_URL,
        "tasks/orders/" + "?order_id=" + this.$route.query.orderId,
        "get"
      )
        .then(data => {
          this.loading = false;
          this.callOrderId = data.data[0].extra;
          if (this.callOrderId.status === 0) {
            this.isEditable = true;
          }
        })
        .catch(err => {
          this.loading = false;
        });
    }
    this.getTaskDetail();
  }
};
</script>